import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {ListWrapper} from './list/List'

const authorsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Gerenciamento de Crianças',
    path: '/apps/childrens-management/childrens',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]




const Page = () => {


  return (
    <>
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='childrens'
          element={
            <>
              <PageTitle breadcrumbs={authorsBreadcrumbs}>Lista de Crianças</PageTitle>
              <ListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/childrens-management/childrens' />} />
    </Routes>
    </>
  )
}

export default Page
